













import Vue from "vue";
import ImageViewRound from "@/components/atoms/ImageView.vue";
import { showOkCancelDialog } from "@/lib/dialog";

export default Vue.extend({
  components: { ImageViewRound },
  props: {
    to: Object,
    icon: String,
    label: String,
    iconPlaceholder: String,
    isActive: Boolean,
    showHandle: Boolean,
    item: Object,
    enableFolder: Boolean,
    enableDelete: Boolean,
    customClickFunction: Function, // click時の挙動を外部から指定したい場合用に渡す
    needsDoCustomClickFunction: Boolean, // customClickFunctionの実行要否の判断用に追加
  },
  methods: {
    async click() {
      if (this.showHandle) {
        return;
      }
      // マルチ執筆画面内での処理でもisModifiedに引っかかってしまうので、その前に処理を行わせている
      if (this.needsDoCustomClickFunction) {
        this.customClickFunction();
        return;
      }
      if (this.isModified()) {
        const yes = await showOkCancelDialog({
          title: "確認",
          content: "保存されていない変更があります。<br />変更を破棄しますか？",
          okButton: "破棄する",
          cancelButton: "キャンセル",
        });
        if (!yes) {
          return;
        }
      }
      this.setModified(false);
      this.$router.push(this.to);
    },
    setFolder(item) {
      this.$emit("clickSetFolder", {
        item,
      });
    },
    deleteItem() {
      this.$emit("delete");
    },
  },
});
